import {
    AgreementParam,
    UpdateSiteGuideParam,
    SiteGuideVo,
    ShowSiteGuideUsingGetParams,
} from '@servicesTypings/drpRequest'
import { GetUrlUsingGetParams } from '@servicesTypings/companyRequest'
import { companyRequest, drpRequest, goodsRequest } from '@/utils/request'

// 获取页面操作的协议是否已经确认
/**
 * 获取商家是否签署协议
 */
export function hasSignAgreement(data: AgreementParam): API.Res<boolean> {
    return drpRequest.post('/config/hasSignAgreement', { data })
}

// 签订协议
/**
 * 商家签署协议
 */
export function signAgreement(data: AgreementParam): API.Res<boolean> {
    return drpRequest.post('/config/signAgreement', { data })
}

// 获取地址库地址
/**
 * 获取地址json文件url
 */
export function getAddressUrl(params: GetUrlUsingGetParams): API.Res<string> {
    return companyRequest.get('/open/address/getUrl', { params })
}

/**
 * 完成引导
 */
export function updateSiteGuide(data: UpdateSiteGuideParam): API.Res<object> {
    return drpRequest.post('/config/updateSiteGuide', { data })
}

/**
 * 获取供应商引导
 */
export function getSiteGuideForSupplier(): API.Res<SiteGuideVo> {
    return drpRequest.get('/config/getSiteGuideForSupplier')
}

/**
 * 获取分销商引导
 */
export function getSiteGuideForChannel(): API.Res<SiteGuideVo> {
    return drpRequest.get('/config/getSiteGuideForChannel')
}

/**
 * 是否显示新手引导
 */
export function showSiteGuide(params: ShowSiteGuideUsingGetParams): API.Res<boolean> {
    return drpRequest.get('/config/showSiteGuide', { params })
}

// 查询分销加价开关
/**
 * 查询分销加价开关
 */
export function queryDrpAddPriceSwitch(): API.Res<boolean> {
    return goodsRequest.get('/drpAddPrice/queryDrpAddPriceSwitch')
}

// 修改分销加价开关
export function modifyDrpAddPriceSwitch(data, authOptions) {
    return goodsRequest.post('/drpAddPrice/modifyDrpAddPriceSwitch', {
        data,
        authOptions,
    })
}
